// src/pages/NotFoundPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui';

export default function NotFoundPage() {
    const navigate = useNavigate();
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', gap: 16, textAlign: 'center', padding: 24 }}>
            <div style={{ fontFamily: 'var(--font-display)', fontSize: '6rem', fontWeight: 800, color: 'var(--green-800)', lineHeight: 1 }}>404</div>
            <h2 style={{ fontFamily: 'var(--font-display)', color: 'var(--text-primary)' }}>Page Not Found</h2>
            <p style={{ color: 'var(--text-tertiary)', maxWidth: 320 }}>The page you're looking for doesn't exist or you don't have access to it.</p>
            <Button variant="primary" onClick={() => navigate('/')}>Back to Dashboard</Button>
        </div>
    );
}
